/*
Pantalla para restaurar contraseña 
 */

import React, { useState } from 'react';

//REDUX
import { useDispatch } from "react-redux";
import { changeUserAction } from "../../redux/actions/userActions";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
    root: {
        marginTop: "10px",
        display: "flex"
    },
    border: {
        boxShadow: "0px 0px 3px 1px #9abf3a",
        paddingTop: "20px",
        paddingBottom: "20px",
        marginTop: "30px",
        marginBottom: "50px"
    },
    form: {
        width: "90%",
        marginTop: theme.spacing(3),
        paddingBottom: "20px"
    }
}));
//#endregion

export default function RestorePassword({ history, match }) {
    const classes = useStyles();

    const { userId, oldPassword, mail } = match.params;

    //#region Values
    const [formValues, setFormValues] = useState({
        showSnackBar: false,
        snackMessage: "Datos modificados",
        showPassword: false,
        editPassword: false,
        editMail: false,
        errorMessage: "",
        showPrivacity: false,
    });
    const [values, setValues] = useState({
        oldPassword: oldPassword,
        password: "",
        repassword: "",
    });
    const [checkValues, setCheckValues] = useState({
        oldPassword: false,
        password: false,
        repassword: false,
    });
    //#endregion

    //#region DISPATCH & SELECTOR
    const dispatch = useDispatch();

    //#endregion

    //#region Functions
    const checkSpecialCondition = (atribute, value) => {
        let result = {
            check: false,
            errorMessage: "",
        };
        switch (atribute) {
            case "password":
                if (!/^[a-z0-9_-]{6,16}$/i.test(value)) {
                    result.check = true;
                    result.errorMessage = "La contraseña debe tener al entre 6 y 16 caracteres.";
                } else {
                    result.check = false;
                    result.errorMessage = "";
                }
                break;
            case "repassword":
                if (values.password !== value) {
                    result.check = true;
                    result.errorMessage = "Las contraseñas deberian coincidir.";
                } else {
                    result.check = false;
                    result.errorMessage = "";
                }
                break;
            default:
                break;
        }

        return result;
    };
    //#endregion


    //#region OnBlur
    const handleBlur = prop => event => {
        let check = checkSpecialCondition(prop, event.target.value);
        setValues({
            ...values,
            [prop]: event.target.value,
        });
        setCheckValues({
            ...checkValues,
            [prop]: check.check,
        });
        setFormValues({
            ...formValues,
            errorMessage: check.errorMessage,
        });
    };
    //#endregion

    //#region HandleChange
    const handleChange = prop => event => {
        setValues({
            ...values,
            [prop]: event.target.value,
        });
        setCheckValues({
            ...checkValues,
            [prop]: false,
        });
    };
    const handleChangeFormValuesBoolean = prop => event => {
        setFormValues({
            ...formValues,
            [prop]: !formValues[prop],
        });
    };
    const handleMouseDownPassword = event => {
        event.preventDefault();
    };
    //#endregion

    //#region OnClick
    const onClickBackLogin = () => {
        history.push("/" + mail);
    };
    const onClickChangePassword = e => {
        e.preventDefault();
        let checkPassword = checkSpecialCondition("repassword", values.repassword);
        setFormValues({ ...formValues, errorMessage: checkPassword.errorMessage });
        if (values.oldPassword === "" || !values.repassword === "" || !values.password === ""
            || checkSpecialCondition("password", values.password).check || checkPassword.check) {
            setCheckValues({ ...checkValues, oldPassword: values.oldPassword === "" ? true : false, repassword: true, password: true });
        } else {
            const changeUser = (userId, user, isChangePassword) => dispatch(changeUserAction(userId, user, isChangePassword));
            changeUser(userId, values, true).then(v => {
                history.push("/" + mail);
            }).catch(error => {
                if (error) {
                    switch (error.status) {
                        case 409:
                            if (error.data === "password") {
                                setFormValues({
                                    ...formValues,
                                    errorMessage: "Error en la contraseña actual",
                                });
                            }
                            if (error.data === "email") {
                                setFormValues({
                                    ...formValues,
                                    errorMessage: "Email ya registrado",
                                });
                            }
                            break;
                        default:
                            setFormValues({
                                ...formValues,
                                errorMessage: "Error del servidor, intente más tarde",
                            });
                            break;
                    }
                }
            });
        }
    }
    //#endregion

    return (
        <div className={classes.root}>
            <form className={classes.form} noValidate>
                <Grid container spacing={2} justify="center" alignItems="center">
                    <Fade in={true} timeout={1000}>
                        <Grid
                            container
                            item
                            xs={10}
                            md={8}
                            lg={5}
                            xl={2}
                            spacing={2}
                            justify="center"
                            alignItems="center"
                            className={classes.border}
                        >
                            <Grid item xs={10} className="mb-4">
                                <Box textAlign="center">
                                    <Typography color="secondary" variant="h5" data-lang="restore_title">
                                        Restaurar contraseña
                                            </Typography>
                                </Box>
                            </Grid>
                            {formValues.errorMessage.length > 0 ? (
                                <Grid item xs={12}>
                                    <div className="alert alert-danger" role="alert" data-lang={formValues.errorMessage}>
                                        {formValues.errorMessage}
                                    </div>
                                </Grid>
                            ) : null}
                            <Grid item xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="outlined-adornment-old-password" error={checkValues.oldPassword ? true : false}>
                                        <span data-lang="restore_current_password_label">Contraseña actual *</span>
                                                            </InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-old-password"
                                        type={formValues.showPassword ? "text" : "password"}
                                        value={values.oldPassword}
                                        error={checkValues.oldPassword ? true : false}
                                        autoComplete="old-password"
                                        onChange={handleChange("oldPassword")}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    data-lang-attr="aria-label"
                                                    data-lang-aria-label="profile_toggle_password"
                                                    onClick={handleChangeFormValuesBoolean("showPassword")}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={155}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="outlined-adornment-password" error={checkValues.password ? true : false}>
                                        <span data-lang="restore_new_password_label">{"Contraseña nueva * (min. 6)"}</span>
                                    </InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type={formValues.showPassword ? "text" : "password"}
                                        value={values.password}
                                        autoFocus
                                        error={checkValues.password ? true : false}
                                        autoComplete="new-password"
                                        onChange={handleChange("password")}
                                        onBlur={handleBlur("password")}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    data-lang-attr="aria-label"
                                                    data-lang-aria-label="profile_toggle_password"
                                                    onClick={handleChangeFormValuesBoolean("showPassword")}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={215}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="outlined-adornment-repassword" error={checkValues.repassword ? true : false}>
                                        <span data-lang="restore_repeat_password_label">Repetir contraseña *</span>
                                                        </InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-repassword"
                                        type={formValues.showPassword ? "text" : "password"}
                                        value={values.repassword}
                                        error={checkValues.repassword ? true : false}
                                        autoComplete="new-password"
                                        onChange={handleChange("repassword")}
                                        onBlur={handleBlur("repassword")}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    data-lang-attr="aria-label"
                                                    data-lang-aria-label="profile_toggle_password"
                                                    onClick={handleChangeFormValuesBoolean("showPassword")}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {formValues.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={163}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Button fullWidth variant="contained" color="secondary" onClick={onClickBackLogin} data-lang="back">
                                    Atrás
                            </Button>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Button
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    onClick={e => onClickChangePassword(e)}
                                    data-lang="restore_change_password"
                                >
                                    Cambiar contraseña
                            </Button>
                            </Grid>
                        </Grid>
                    </Fade>
                </Grid>
            </form>
        </div >
    );
}
